import i18next from 'i18next';
import React from 'react';
import { getInputLabel, renderPolygons } from "../../helper";

export function RiskPlan({
  conf: {
    input,
    values
  }
}) {
  const colors = {
    5: '207, 19, 34',
    4: '255, 77, 79',
    3: '250, 140, 22',
    2: '250, 219, 20',
    1: '115, 209, 61',
    0: '243, 243, 243',
  };
  const score = (values.assessment || {}).vulnerability || 0;
  const color = colors[score] || colors[0];

  return <div className="risk-plan">
    <h1>{i18next.t('vulnerability')}</h1>
    <div className="subScore">
      <div className="cont">
        {renderPolygons({ value: score, color: `rgb(${color})` })}
      </div>
      <div>
        {getInputLabel(input, values)}
      </div>
    </div>
  </div>
}